import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle: string;
  children: ReactNode;
}

export default function AuthCard({ title, subtitle, children }: Props) {
  return (
    <main className="min-h-dvh flex items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-sm">
        <header className="text-center mb-8">
          <h1 className="text-2xl font-medium text-gray-900">{title}</h1>
          <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
        </header>
        {children}
      </div>
    </main>
  );
}
